// جلب كل مستخدمي المطبخ
export const getAllKitchenUsers = async () => {
  const subdomain = window.location.hostname.split(".")[0] || "test01";
  const apiPassword = "Project102$_";
  const token = localStorage.getItem("token");

  const apiUrl = `https://${subdomain}.restocash.app/api/kitchen/users?api_password=${apiPassword}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب مستخدمي المطبخ.");
  }

  return data.users || [];
};

// ربط مستخدم بمطبخ
export const addUserToKitchen = async ({ user_id, kitchen_id }) => {
  const subdomain = window.location.hostname.split(".")[0] || "test01";
  const apiPassword = "Project102$_";
  const token = localStorage.getItem("token");

  const apiUrl = `https://${subdomain}.restocash.app/api/add/user/kitchen?api_password=${apiPassword}`;

  const formData = new FormData();
  formData.append("user_id", user_id);
  formData.append("kitchen_id", kitchen_id);

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في ربط المستخدم بالمطبخ.");
  }

  return data;
};

// إزالة مستخدم من مطبخ
export const removeUserFromKitchen = async ({ user_id, kitchen_id }) => {
  const subdomain = window.location.hostname.split(".")[0] || "test01";
  const apiPassword = "Project102$_";
  const token = localStorage.getItem("token");

  const apiUrl = `https://${subdomain}.restocash.app/api/remove/user/kitchen?api_password=${apiPassword}`;

  const formData = new FormData();
  formData.append("user_id", user_id);
  formData.append("kitchen_id", kitchen_id);

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في إزالة المستخدم من المطبخ.");
  }

  return data;
};
